// Widget CSS
import '@/css/_elementor/widgets/card_slider.css';

// ..........................................................................................

import { ShuffleColors } from '@/js/utilities/color-shuffle';

// ..........................................................................................

// function initThisCarousel(scopeEl) {
// 	const slider1 = scopeEl.querySelector('.slider-card_slider');

// 	if (slider1) {
// 		const wrapper = slider1.querySelector('.swiper-wrapper');
// 		const slides = Array.from(wrapper.children);
// 		const slidesCount = slides.length || 1;
// 		// const slidesCount = parseInt(slider1.dataset.slide_count) || 1;

// 		const cardSlider = new Swiper(slider1, {
// 			speed: 750,
// 			loop: true,
// 			freeMode: true,
// 			grabCursor: true,
// 			watchSlidesProgress: true,
// 			spaceBetween: 14,
// 			slidesPerView: 1,
// 			slidesOffsetAfter: 20,

// 			breakpoints: {
// 				768: {
// 					slidesPerView: 2,
// 					spaceBetween: 16,
// 					initialSlide: 1,
// 					centeredSlides: true,
// 					slidesOffsetAfter: 0,
// 				},
// 				1280: {
// 					slidesPerView: slidesCount > 4 ? 4 : slidesCount,
// 					spaceBetween: 24,
// 					initialSlide: 0,
// 					centeredSlides: true,
// 					slidesOffsetAfter: 0,
// 				},
// 			},
// 			pagination: {
// 				el: '.slider-card_slider .swiper-pagination',
// 				type: 'bullets',
// 				dynamicBullets: false,
// 				clickable: true,
// 			},
// 			// navigation: {
// 			// 	nextEl: '.slider-card_slider .slider-button-next',
// 			// 	prevEl: '.slider-card_slider .slider-button-prev',
// 			// },
// 		});
// 	}
// }

function initThisCarousel(scopeEl) {
	const slider1 = scopeEl.querySelector('.slider-card_slider');

	if (!slider1) return;

	const wrapper = slider1.querySelector('.swiper-wrapper');
	const slidesCount = wrapper.children.length || 1;

	const cardSlider = new Swiper(slider1, {
		speed: 750,
		loop: true,
		loopPreventsSliding: false,
		loopAdditionalSlides: 6,
		threshold: 0,

		grabCursor: true,
		watchSlidesProgress: true,
		watchSlidesVisibility: false,

		freeMode: {
			enabled: true,
			sticky: false,
			momentum: true,
			momentumRatio: 1,
			momentumVelocityRatio: 1,
			momentumBounce: false,
		},

		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},

		spaceBetween: 14,
		slidesPerView: 1,
		slidesOffsetAfter: 20,
		initialSlide: 0,

		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 16,
				centeredSlides: true,
				slidesOffsetAfter: 0,
			},
			1280: {
				slidesPerView: Math.min(4, slidesCount),
				spaceBetween: 24,
				centeredSlides: true,
				slidesOffsetAfter: 0,
			},
		},

		pagination: {
			el: slider1.querySelector('.swiper-pagination'),
			clickable: true,
		},

		on: {
			// Immediately check/fix the loop while dragging.
			sliderMove(swiper) {
				swiper.loopFix();
			},

			// Also fix it immediately after the finger/mouse is released.
			touchEnd(swiper) {
				swiper.loopFix();
			},

			// Keep everything in sync after loopFix.
			loopFix(swiper) {
				swiper.updateSlides();
				swiper.updateProgress();
				swiper.updateSlidesClasses();
			},
		},
	});
}

// ......

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/card_slider.default', (scope) => {
		const scopeEl = scope[0];

		// ......................................................

		const Slider = scopeEl.querySelector('.slider-card_slider');

		if (!Slider) return;

		new ShuffleColors({
			container: Slider,
			items: '.card',
			colors: ['#C9D0FC', '#E74C28', '#F9D757', '#61A2F8', '#B0EAC3'],
		});

		// ......................................................

		// initThisCarousel(scopeEl);

		//
	});
});
